import { entities } from "sbtech-sports-data-api-client";
import * as Models from "../../Models";
import { getCurrentTime } from "sb-resp-lib"
import { MarketsObject } from "../../Interfaces";

export enum VenuRole {
    Home = "Home",
    Away = "Away",
}

export class EventParser {

    public static parse(newEvent: entities.SportEvent, currentTimeZone, sortId: string, eventMarketsIds: string[]): Models.Event {

        let marketsIds: string[] = [];

        // ugly code due to wrong entity property type
        marketsIds = eventMarketsIds;
        let convertedDate = Date.fromISO(newEvent.startEventDate);
        let eventDate = convertedDate ? getCurrentTime(convertedDate, currentTimeZone) : undefined;
        let eventStartingDate = eventDate ? eventDate.formatDate("dd/MM") : "--";
        let eventStartingTime = eventDate ? eventDate.formatDate("HH:mm") : "--";

        let participant1 = this.getParticipantName(newEvent, 0, VenuRole.Home);
        let participant2 = this.getParticipantName(newEvent, 1, VenuRole.Away);

        return new Models.Event({
            eventName: newEvent.eventName ? newEvent.eventName : "",
            sportName: newEvent.sportName,
            sportSortId: newEvent.sportOrder.toString(),
            sortId,
            marketLinesCount: newEvent.marketLinesCount,
            sportId: newEvent.sportId,
            leagueId: newEvent.leagueId,
            participant1Name: participant1,
            participant2Name: participant2,
            marketIds: marketsIds,
            id: newEvent.id,
            leagueName: newEvent.leagueName,
            eventStartingDate,
            eventStartingTime,
            eventDate: newEvent.startEventDate,
            isTeamSwapEnabled: false,
            personalizedSortId: "",
            linkAddress: ""
        })
    }

    /*public static getMarketIds(newEvent: entities.SportEvent) {
        let marketsIds: string[] = [];

        // ugly code due to wrong entity property type
        for (let index = 0; index < newEvent.markets.length; index++) {
            let market = newEvent.markets[index];
            if (typeof market === "string") {
                marketsIds.push(market);
            }
        }

        return marketsIds;
    }*/

    public static getFilteredMarketIds(newEvent: entities.SportEvent, markets: MarketsObject) {
        let marketsIds: string[] = [];

        for (var key in markets) {
            if (markets.hasOwnProperty(key)) {
                let market = markets[key];
                if (market.eventId === newEvent.id)
                {
                    marketsIds.push(market.id)
                }
            }
        }

        /*
        // ugly code due to wrong entity property type
        for (let index = 0; index < newEvent.markets.length; index++) {
            let marketId = newEvent.markets[index];
            if (typeof marketId === "string") {

                let market = markets[marketId];
                market && marketsIds.push(marketId);
            }
        }*/

        return marketsIds;
    }

    public static getParticipantName(newEvent: entities.SportEvent, index: number, venueRole: entities.VenueRole) {

        let participant = newEvent.participants.find((par) => par.venueRole === venueRole);
        let participantName = (participant) ?
                participant.name :
                (newEvent.participants[index] ? newEvent.participants[index].name : "");

        return participantName;
    }

}
